import axios from 'axios';
import { DCR_API_BASE_SERVER_URL } from 'config';
import type { ClosedLostReportInput } from '@trnsact/trnsact-shared-types';

const FALLBACK_FILE_NAME = 'closed-lost-report.csv';

const extractFilenameFromContentDisposition = (header?: string): string => {
  if (!header) {
    return FALLBACK_FILE_NAME;
  }

  const utf8Match = header.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1]);
  }

  const filenameMatch = header.match(/filename="?([^";]+)"?/i);
  if (filenameMatch?.[1]) {
    return filenameMatch[1];
  }

  return FALLBACK_FILE_NAME;
};

export const exportClosedLostReport = async (input: ClosedLostReportInput): Promise<void> => {
  const response = await axios.post(`${DCR_API_BASE_SERVER_URL}/closed-lost-report`, input, {
    responseType: 'blob',
    headers: {
      Accept: 'text/csv',
    },
  });

  const fileName = extractFilenameFromContentDisposition(response.headers['content-disposition']);
  const fileUrl = window.URL.createObjectURL(response.data);
  const link = document.createElement('a');
  link.href = fileUrl;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(fileUrl);
};
